import type { ReactNode } from 'react';

export function SelectGroupHeading({ children }: { children: ReactNode }) {
  return <div className="body-200-heavy flex h-8 w-full items-center px-4 text-neutral-1000">{children}</div>;
}
